import React from "react";
import { Coming } from "../../../components/Coming/Coming";

const Message = () => {
  return (
    <div>
      <Coming />
    </div>
  );
};

export default Message;
